'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _parseFloat = require('babel-runtime/core-js/number/parse-float');

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripKlantbeoordelingReviewnavigatorV1.$inject = ['$http', '$q'];


var _module = angular.module('cb.strips.cbStripKlantbeoordelingReviewnavigatorV1', []);

_module.directive('cbStripKlantbeoordelingReviewnavigatorV1', cbStripKlantbeoordelingReviewnavigatorV1);

exports.default = _module;


function cbStripKlantbeoordelingReviewnavigatorV1($http, $q) {
    cbStripKlantbeoordelingReviewnavigatorV1Controller.$inject = ['$scope', '$window', 'XmlToJsonService', '$sce', 'EnvironmentService'];

    return {
        restrict: 'A',
        controller: cbStripKlantbeoordelingReviewnavigatorV1Controller
    };

    function cbStripKlantbeoordelingReviewnavigatorV1Controller($scope, $window, XmlToJsonService, $sce, EnvironmentService) {
        var version = 1.00;
        var reviewsPerPage = 4;
        // define two xml urls, and use a dummy if we are currently working in development environment
        var dummyXML = '/assets/mobilefirst/xml/company-reviews-dummy.xml';
        var reviewXML = '/assets/xml/company-reviews.xml';
        var xmlUrl = EnvironmentService.isDevelopment() ? dummyXML : reviewXML;
        var jsonData = void 0;
        $scope.activePage = 1;
        $scope.totalPages = 0;
        $scope.visibleReviews = {
            min: 0,
            max: 0
        };
        $scope.activeFilters = {
            product: null,
            score: null,
            period: null
        };

        getReviewXML(xmlUrl).then(function (result) {
            jsonData = XmlToJsonService.convert(result);
            var data = jsonData.default;
            var allReviews = formatReviews(data.review_list.review);
            var reviews = allReviews;
            $scope.totalPages = Math.ceil(reviews.length / reviewsPerPage);

            $scope.company = data.company;
            $scope.products = getProducts(data.review_list.review);
            $scope.months = getMonths(data.review_list.review);
            $scope.reviews = getPaginatedReviews($scope.activePage);
            $scope.totalPages = Math.ceil(reviews.length / reviewsPerPage);

            // a formatter so html entities will be rendered corectly
            $scope.formatHTML = function (html) {
                html = html.replace(/(?:\r\n|\r|\n)/g, '<br />');
                var decoded = angular.element('<textarea />').html(html).text();
                return $sce.trustAsHtml(decoded);
            };

            $scope.changePage = function (newPage) {
                $scope.activePage = newPage;
                $scope.reviews = getPaginatedReviews($scope.activePage);
            };

            $scope.getFilteredReviews = function () {
                var filteredReviews = allReviews;

                if ($scope.activeFilters.product) {
                    filteredReviews = filteredReviews.filter(function (review) {
                        return review.product === $scope.activeFilters.product;
                    });
                }

                if ($scope.activeFilters.score) {
                    if ($scope.activeFilters.score === 'higherThan5') {
                        filteredReviews = filteredReviews.filter(function (review) {
                            return review.totalScore > 5;
                        });
                    } else if ($scope.activeFilters.score === 'lowerThan5') {
                        filteredReviews = filteredReviews.filter(function (review) {
                            return review.totalScore < 5;
                        });
                    }
                }

                if ($scope.activeFilters.period) {
                    filteredReviews = filteredReviews.filter(function (review) {
                        return review.date.getMonth() === parseInt($scope.activeFilters.period, 10);
                    });
                }

                $scope.activePage = filteredReviews.length > 0 ? 1 : 0;
                reviews = filteredReviews;
                $scope.totalPages = Math.ceil(reviews.length / reviewsPerPage);
                $scope.reviews = getPaginatedReviews(1);
            };

            $scope.toggleReview = function (targetIndex) {
                var review = $window.document.querySelectorAll('#review-' + targetIndex);
                angular.element(review).toggleClass('closed');
            };

            function getPaginatedReviews(pageNumber) {
                // update visible reviews, because we're chaning them
                $scope.visibleReviews.min = pageNumber * reviewsPerPage - (reviewsPerPage - 1);
                $scope.visibleReviews.max = pageNumber * reviewsPerPage;
                // because pages logically start with 1, but technically with 0
                --pageNumber;
                return reviews.slice(pageNumber * reviewsPerPage, (pageNumber + 1) * reviewsPerPage);
            };
        });
    }

    function getProducts(reviews) {
        // find wich product a review is for
        var products = reviews.map(function (review) {
            return (0, _get3.default)(review, 'extraquestions.multiple_choice.answer');
        });

        // remove duplicates
        products = (0, _uniq3.default)(products);

        // remove undefined values
        products = products.filter(function (value) {
            return value !== undefined;
        });

        return products;
    }

    function getMonths(reviews) {
        var monthNames = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];

        //get the month a review has been posted in
        var months = reviews.map(function (review) {
            return new Date(review.customer.date).getMonth();
        });

        // remove duplicates and sort
        months = (0, _uniq3.default)(months).sort();

        // map to objects to render month dropdown with
        months = months.map(function (month) {
            return {
                value: month,
                name: monthNames[month]
            };
        });

        return months;
    }

    function formatReviews(reviews) {
        return reviews.map(function (review) {
            return {
                date: new Date(review.customer.date),
                product: (0, _get3.default)(review, 'extraquestions.multiple_choice.answer'),
                totalScore: review.total_score,
                totalScoreFormatted: (0, _parseFloat2.default)(review.total_score) < 10 ?
                // parse the number, format it to one decimal, convert to string and replace the dot with a comma
                (0, _parseFloat2.default)(review.total_score).toFixed(1).toString().replace('.', ',') : review.total_score,
                customer: {
                    name: review.customer.name || 'Anoniem',
                    place: review.customer.place
                },
                positive: review.positive ? review.positive : '-',
                negative: review.negative ? review.negative : '-',
                // if there's a double enter split the text so we can render it in a new paragraph
                reaction: review.reaction ? review.reaction.split(/\r?\n\n/) : '-'
            };
        });
    }

    function getReviewXML(url) {
        var reviews = $q.defer();

        $http({
            method: 'GET',
            url: url
        }).then(function successCallback(response) {
            reviews.resolve(response.data);
        }, function errorCallback(response) {
            reviews.reject(response.status);
        });

        return reviews.promise;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/klantbeoordeling-reviewnavigator-v1/klantbeoordeling-reviewnavigator.directive.js
// module id = 949
// module chunks = 1